var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadCaretLeft = function SvgFadCaretLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.921 171.679c.237 15.682-19.642 24.306-31.005 12.728-11.362-11.578-35.01-36.026-42.474-43.357-7.464-7.331-5.271-19.546.898-26.332 6.169-6.786 31.326-30.824 42.842-42.232 11.515-11.408 29.502-3.618 29.502 11.835 0 15.453 0 71.675.237 87.358z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.673 170.838c1.555 1.562 3.031 2.214 3.02 0V85.766c-.012-2.21-.408-3.183-1.956-1.605l-41.117 41.082c-1.548 1.577-1.535 4.13.013 5.684l40.04 39.91z",
    fill: "#FFF"
  }))));
};
export { SvgFadCaretLeft as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-caret-left.ed2b31ff.svg";